import React, { Component } from 'react';

class BuscadorRubros extends Component {
    constructor(props) {
        super(props);
        this.changeRubro = this.changeRubro.bind(this);
    }

    changeRubro(event) {
        let valueBuscador = event.target.value;
        this.props.changeRubro(valueBuscador, true);
    }

    render() {
        return (
            <div className="row" >
                <div className="col-xs-12">
                    <div class="input-icon-container">
                        <span className="ti-search input-icon-span"></span>
                        <input
                            id={this.props.idBuscador}
                            className="form-control input-with-icon"
                            list={this.props.idLista}
                            placeholder={this.props.placeholder}
                            disabled={this.props.disabled}
                            value={this.props.value}
                            onChange={this.changeRubro} />
                    </div>
                    <datalist id={this.props.idLista}>
                        {this.props.rubros}
                    </datalist>
                </div>
            </div>);
    }
};

export default BuscadorRubros;